(function() {
  function initSolarScroll() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      setTimeout(initSolarScroll, 50);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const wrapper = document.querySelector(".sunty-scroll-wrapper");
    if (!wrapper) return;

    const track = wrapper.querySelector(".sunty-cards-track");
    const cards = wrapper.querySelectorAll(".sunty-card-item");

    // Add natural subtle organic rotation variables to cards
    cards.forEach((card) => {
      const randomRotation = (Math.random() - 0.5) * 7; // -3.5deg to +3.5deg range
      card.style.setProperty('--rotation', `${randomRotation}deg`);
    });

    // Dynamic transform distance map calculation
    const getScrollDistance = () => {
      return -(track.offsetWidth - window.innerWidth + (window.innerWidth * 0.15));
    };

    // Smooth scroll pinning animation setup
    gsap.to(track, {
      x: () => getScrollDistance(),
      ease: "none",
      scrollTrigger: {
        trigger: wrapper,
        start: "top top",
        end: () => `+=${track.offsetWidth}`,
        scrub: 1.2, // Higher numbers enhance catchup slide smoothness
        pin: true,
        invalidateOnRefresh: true
      }
    });
  }

  // Inject required external animation libraries if missing
  if (!document.getElementById("gsap-base-cdn")) {
    const gsapScript = document.createElement("script");
    gsapScript.id = "gsap-base-cdn";
    gsapScript.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js";
    document.head.appendChild(gsapScript);
  }

  if (!document.getElementById("gsap-trigger-cdn")) {
    const triggerScript = document.createElement("script");
    triggerScript.id = "gsap-trigger-cdn";
    triggerScript.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/ScrollTrigger.min.js";
    document.head.appendChild(triggerScript);
  }

  window.addEventListener("load", initSolarScroll);
})();